'use client';

import AuthCustomerLayout from '@/components/layout/auth-customer-layout';
import { OrderTabsCustomer } from '@/components/sections/builder/elements/body/customer/customer_order/component/tabs';
import { CustomerOrderElementDataType } from '@/components/sections/builder/elements/body/customer/customer_order/type';
import { ElementProps } from '@/components/sections/builder/types';
import React from 'react';

export default function ELementContentCustomerOrder({ element, preview, host }: ElementProps) {
  const content = element.data as CustomerOrderElementDataType;

  return (
    <AuthCustomerLayout isPreview={preview} host={host as string}>
      <div className='bg_scheme_customer_order customer_order_padding w-full'>
        <div className='theme_layout_page_width mx-auto flex flex-col gap-3 px-6 md:px-8 xl:px-0'>
          <h1 className='mb-12 text-2xl'>Order History</h1>
          <div className='w-full'>
            <OrderTabsCustomer content={content} preview={preview} />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .bg_scheme_customer_order {
            background-color: ${content.colorScheme?.background || 'white'};
            color: ${content.colorScheme?.text || '#52535B'};
          }
          .customer_order_padding {
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
          }
        `}
      </style>
    </AuthCustomerLayout>
  );
}
